<template>
  <teleport to="#teleport-toast">
    <transition-group
      tag="div"
      name="fade"
      class="fixed top-0 right-0 mt-8 mr-8 m-h-screen flex flex-col"
      style="z-index: 9999"
    >
      <div v-for="item in toastItems" :key="item.id">
        <div
          class="flex flex-row justify-between items-center mt-1 px-4 py-2 bg-secondary-main"
          style="min-height: 32px; width: 400px; border-radius: 4px"
        >
          <div class="flex text-white text-sm leading-4 mr-2">
            {{ item.content }}
          </div>
          <div>
            <button
              class="focus:outline-none"
              style="width: 14px; height: 14px"
              aria-label="close"
              @click="clearToast(item.id)"
            >
              <img src="@/assets/icons/Exit.svg" />
            </button>
          </div>
        </div>
      </div>
    </transition-group>
  </teleport>
</template>
<script>
import { inject } from 'vue';

export default {
  setup() {
    const globalStore = inject('globalStore');
    const globalMethods = inject('globalMethods');

    return {
      clearToast: globalMethods.clearToast,
      toastItems: globalStore.toast.items,
    };
  },
};
</script>
<style></style>
